import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { BRAND, NAV } from "@/config/site";
import { goToForm, scrollToHash } from "@/lib/prefill";

export const Header = () => {
  const [compact, setCompact] = useState(false);
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const isHome = pathname === "/";

  useEffect(() => {
    const onScroll = () => setCompact(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (href) => { setOpen(false); isHome ? scrollToHash(href) : navigate(`/${href}`); };
  const cta = () => { setOpen(false); isHome ? goToForm({}) : navigate("/#contatti"); };

  return (
    <header data-testid="site-header"
            className={`fixed inset-x-0 top-0 z-50 bg-warm/95 backdrop-blur-md border-b border-ivory-dark transition-shadow duration-300 ${compact ? "shadow-[0_1px_0_rgba(176,141,87,0.35),0_8px_24px_rgba(31,61,43,0.06)]" : ""}`}>
      <div className={`container-ph flex items-center justify-between gap-6 transition-[height] duration-300 ${compact ? "h-14 lg:h-[62px]" : "h-16 lg:h-[70px]"}`}>
        <a href="/#home" onClick={(e) => { e.preventDefault(); go("#home"); }} className="flex flex-col items-start shrink-0" data-testid="header-logo" aria-label="Progetto HOSPITALITY">
          <img src={BRAND.monogram} alt="Progetto HOSPITALITY" className={`w-auto object-contain transition-[height] duration-300 ${compact ? "h-7 lg:h-8" : "h-8 lg:h-9"}`} data-testid="header-logo-image" />
          <span className="mt-1 font-serif text-[10px] lg:text-[11px] font-semibold tracking-[0.22em] uppercase leading-none text-forest whitespace-nowrap" data-testid="header-logo-text">{BRAND.name}</span>
        </a>

        <nav className="hidden lg:flex items-center gap-4 xl:gap-6 whitespace-nowrap" aria-label="Navigazione principale" data-testid="desktop-nav">
          {NAV.map((n) => (
            <a key={n.href} href={`/${n.href}`} onClick={(e) => { e.preventDefault(); go(n.href); }}
               data-testid={`nav-link-${n.href.slice(1)}`}
               className="text-xs xl:text-[13px] font-medium tracking-wide text-forest transition-colors duration-200 hover:text-bronze">
              {n.label}
            </a>
          ))}
          <button onClick={cta} data-testid="header-cta-button" className="btn-primary !py-2.5 !px-4 xl:!px-5 !text-[11px] xl:!text-xs">RICHIEDI CONSULENZA</button>
        </nav>

        <button className="lg:hidden p-2 text-forest" onClick={() => setOpen(!open)}
                aria-label={open ? "Chiudi menu" : "Apri menu"} aria-expanded={open} data-testid="mobile-menu-toggle">
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-warm border-t border-ivory-dark" data-testid="mobile-menu">
          <nav className="container-ph flex flex-col py-4" aria-label="Navigazione mobile">
            {NAV.map((n) => (
              <a key={n.href} href={`/${n.href}`} onClick={(e) => { e.preventDefault(); go(n.href); }}
                 data-testid={`mobile-nav-link-${n.href.slice(1)}`}
                 className="py-3 text-base font-medium text-forest border-b border-ivory-dark/70 last:border-0">
                {n.label}
              </a>
            ))}
            <button onClick={cta} className="btn-primary mt-4 w-full" data-testid="mobile-header-cta-button">RICHIEDI CONSULENZA</button>
          </nav>
        </div>
      )}
    </header>
  );
};
